import React, { useMemo } from 'react';
import { HiveCoreProvider } from '../../services/hivecore-scene-stream/HiveCoreProvider';
import { HiveCoreScenePanel } from '../../components/HiveCore/HiveCoreScenePanel';
import { WorkspaceTabInstance } from './types';

const DEFAULT_BASE_URL = import.meta.env.VITE_HIVECORE_API_URL || import.meta.env.VITE_BACKEND_URL;
const DEFAULT_JWT = import.meta.env.VITE_HIVECORE_JWT || 'DEV_JWT_FOR_TESTING';

export interface SceneTabProps {
    tab: WorkspaceTabInstance;
    baseUrl?: string;
    jwt?: string;
    isActive: boolean;
}

export const SceneTab: React.FC<SceneTabProps> = ({
    tab,
    baseUrl = DEFAULT_BASE_URL,
    jwt = DEFAULT_JWT,
    isActive,
}) => {
    const className = useMemo(
        () => `workspace-tab ${isActive ? 'is-active' : 'is-inactive'}`,
        [isActive]
    );

    const Content = tab.render;
    if (Content) {
        return (
            <div
                className={className}
                role="tabpanel"
                aria-hidden={!isActive}
                data-scene-id={tab.sceneId}
            >
                {Content()}
            </div>
        );
    }

    return (
        <div
            className={className}
            role="tabpanel"
            aria-hidden={!isActive}
            data-scene-id={tab.sceneId}
        >
            <HiveCoreProvider
                baseUrl={baseUrl}
                jwt={jwt}
                sceneId={tab.sceneId}
                profile={tab.profile}
            >
                <HiveCoreScenePanel />
            </HiveCoreProvider>
        </div>
    );
};
